import PropTypes from 'prop-types';
import React, {
	Component,
} from 'react';
import {
	FormattedMessage,
	FormattedNumber,
	defineMessages,
} from 'react-intl';

import AlertPagesButton from '../AlertPagesButton';
import ExpressiveValue, {
	ExpressiveValueLabelFlow,
	ExpressiveValueSize,
	ExpressiveValueStatus,
} from '~/components/patterns/values/ExpressiveValue';
import IncidentBoxContent from '~/components/patterns/incidents/IncidentBoxContent';
import RemovedFromAlertMetric from './RemovedFromAlertMetric';
import SeparatedBlocks from '~/components/patterns/structures/SeparatedBlocks';

import {
	countPagesSplit,
} from '~/model/alerts';



const messages = defineMessages({
	affected: {
		id: 'ui.alerts.overview.incident.details.affected',
	},
	noLongerMatchingCriteria: {
		id: 'ui.alerts.overview.incident.details.noLongerMatchingCriteria',
	},
	reverted: {
		id: 'ui.alerts.overview.incident.details.reverted',
	},
});



class PagePropertyChangedDetails extends Component {

	render() {
		const {
			incident,
			websiteId,
		} = this.props;

		const isIncidentActive = incident.get('phase') === 'active';

		const numberOfAffected = incident.get('settings').get('statuses').get('primary').reduce((total, changeType) => {
			return total + countPagesSplit(incident, changeType);
		}, 0);

		const hasReverted = incident.get('settings').get('statuses').get('secondary').indexOf(
			incident.get('settings').get('statuses').get('reverted'),
		) === -1;

		const numberOfReverted = countPagesSplit(incident, incident.get('settings').get('statuses').get('reverted'));

		const numberOfNoLongerMatchingCriteria = incident.get('settings').get('statuses').get('secondary').reduce((total, changeType) => {
			return total + countPagesSplit(incident, changeType);
		}, 0);

		const numberOfRemovedFromAlert = incident.get('settings').get('statuses').get('tertiary').reduce((total, changeType) => {
			return total + countPagesSplit(incident, changeType);
		}, 0);

		const numberOfAlertPages = (
			numberOfAffected
			+ numberOfReverted
			+ numberOfNoLongerMatchingCriteria
			+ numberOfRemovedFromAlert
		);

		return (
			<IncidentBoxContent
				button={numberOfAlertPages > 0 && (
					<AlertPagesButton
						focusOnPrimary={isIncidentActive && numberOfAffected > 0}
						incident={incident}
						websiteId={websiteId}
					/>
				)}
			>
				<SeparatedBlocks divider={false}>
					<ExpressiveValue
						label={(
							<FormattedMessage
								{...messages.affected}
								values={{
									count__pages: numberOfAffected,
								}}
							/>
						)}
						labelFlow={ExpressiveValueLabelFlow.Column}
						size={ExpressiveValueSize.Large}
						status={isIncidentActive ? ExpressiveValueStatus.Warning : ExpressiveValueStatus.Neutral}
						value={(
							<FormattedNumber value={numberOfAffected} />
						)}
					/>

					{hasReverted && (
						<ExpressiveValue
							label={(
								<FormattedMessage
									{...messages.reverted}
									values={{
										count__pages: numberOfReverted,
									}}
								/>
							)}
							labelFlow={ExpressiveValueLabelFlow.Column}
							size={ExpressiveValueSize.Large}
							value={(
								<FormattedNumber value={numberOfReverted} />
							)}
						/>
					)}

					<ExpressiveValue
						label={(
							<FormattedMessage
								{...messages.noLongerMatchingCriteria}
								values={{
									count__pages: numberOfNoLongerMatchingCriteria,
								}}
							/>
						)}
						labelFlow={ExpressiveValueLabelFlow.Column}
						size={ExpressiveValueSize.Large}
						value={(
							<FormattedNumber value={numberOfNoLongerMatchingCriteria} />
						)}
					/>
				</SeparatedBlocks>

				{numberOfRemovedFromAlert > 0 && (
					<RemovedFromAlertMetric
						numberOfRemovedFromAlert={numberOfRemovedFromAlert}
					/>
				)}
			</IncidentBoxContent>
		);
	}

}

PagePropertyChangedDetails.propTypes = {
	incident: PropTypes.object.isRequired,
	websiteId: PropTypes.string,
};



export default PagePropertyChangedDetails;
